define('common/views/modal_view',['require','exports','module','common/models/appstate','base/itemview'],function(require, exports, module) {
  "use strict";

  var AppState = require("common/models/appstate"),
      ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    constructor: function() {
      var self = module.exports.__super__.constructor.apply(this, arguments);
      this.render();
      this.$el.appendTo("body");
      this.show();
      return self;
    },
    events: {
      "click .js-close": "hide"
    },
    delegateEvents: function() {
      module.exports.__super__.delegateEvents.apply(this, arguments);
      this.$el.on("hidden.bs.modal", _.bind(this.remove, this));
      this.$el.on("hidden.bs.modal", _.bind(this.trigger, this, "hide"));
      this.$el.on("show.bs.modal", _.bind(this.show, this));
      this.$el.on("hide.bs.modal", _.bind(this.hide, this));
    },
    undelegateEvents: function() {
      module.exports.__super__.undelegateEvents.apply(this, arguments);
      this.$el.off("hidden.bs.modal");
      this.$el.off("hide.bs.modal");
    },
    className: "ed-overlay hidden",
    show: function() {
      this.$(".ed-overlay-container").hide();
      this.$el.toggleClass("hidden",false);
      this.$(".ed-overlay-container").fadeIn(400);
      this.$el.trigger("shown.bs.modal");
      this.triggerMethod("modal:shown");
      this.allowScroll(false);
      this.fixOverlay();
    },
    hide: function() {
      var self = this;
      self.$el.toggleClass("hidden", true);
      self.$el.trigger("hidden.bs.modal");
      this.allowScroll(true);
      this.fixOverlay();
      AppState.setPropsPopUpOpen(false);
    },

    allowScroll: function (allowed) {
      $('body').css({
        overflow: !allowed ? 'hidden' : ''
      });
    },

    fixOverlay: function () {
      $('body').toggleClass('modal-visible');
    }
  });

});

